<template>
   <el-dialog
         v-loading.fullscreen.lock="loading"
        :visible.sync="driverVisible"
        :show-close="false"
        class="driver"
        center
        width="620px"
        :before-close="handleClose">
        <div class="driver_title">司机列表</div>
        <el-table
        :data="tableData"
        class="driver_table"
        style="width: 100%">
            <el-table-column
                label="姓名"
                header-align="center"
                width="130">
                <template slot-scope="scope">
                        <el-radio v-model="radio" :label="scope.row.driver_id">
                            <div class="driver_table_name">
                                <img :src="$imgUrl + scope.row.avatar" alt="">
                                <div>{{scope.row.username}}</div>
                            </div>
                        </el-radio>
                        
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="车型"
                width="220">
                <template  slot-scope="scope">
                    <div>{{scope.row.vehicle_type}}/车长{{scope.row.vehicle_length}}m/{{scope.row.vehicle_model_number ? scope.row.vehicle_model_number.join('、') : ''}}</div>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="报价"
                width="100">
                <template  slot-scope="scope">
                    <div style="color:#FB4841">¥{{scope.row.price}}</div>
                </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                label="操作">
                <template  slot-scope="scope">
                    <el-button type="text" @click="getPhone(scope.row)">查看联系方式</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="driver_action">
            <el-button type="primary" @click="submit">确认选择</el-button>
        </div>
        <phoneModal v-if="phoneVisible" :phoneVisible.sync="phoneVisible" :selectItem="phoneItem"></phoneModal>
   </el-dialog>
</template>

<script>
import phoneModal from './phoneModal'
export default {
    props:["driverVisible","item","driverCallback"],
   data (){
       return {
           tableData: [],
           radio:null,
           phoneVisible:false,
           selectItem:{},
           phoneItem:{
               title:'',
               phone:''
           },
           loading:false
       }
   },
   components: {
       phoneModal
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       getPhone(row){
           this.phoneItem = {
               title:'联系方式',
               phone:row.phone
           };
           this.phoneVisible = true;
       },
       handleClose(){
           this.$emit("update:driverVisible",false);
       },
       submit(){
           if(this.radio === null || !this.radio){
               this.$message.error('请选择司机');
               return
           }
           this.loading = true;
           const url = this.item.driver_id ? 'OrderUpdateDriver' : 'UserConfirmAcceptOrder'
           this.$post(url,{id:this.item.uuid,driver_id:this.radio} )
                .then(data => {
                    this.loading = false;
                    this.$message.success('司机设置成功');
                    if(this.driverCallback){
                        this.driverCallback();
                    }
                    
                    this.$emit("update:driverVisible",false);
                }, error => {
                    this.loading = false;
                    this.$message.error(error);
                });;
           
       },
       getDriverList(){
           this.$get('AcceptOrder/' + this.item.uuid,{})
            .then(data => {
                this.tableData = data;
            }, error => {
                this.$message.error(error);
            });
       }
       
   },
   created() {
       this.radio = this.item.driver_id || '';
       this.getDriverList();
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.driver{
    &_title{
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color:#333;
        margin-bottom:16px;
    }
    &_table{
        &_name{
            display: flex;
            align-items: center;
            img{
                width:30px;
                height:30px;
                border-radius: 30px;
            }
            div{
                font-size: 14px;
                font-weight: 500;
                color:#333;
                margin-left:10px;
            }
        }
        /deep/ .el-radio{
            display: flex;
            align-items: center;
            
        }
        /deep/ th{
            border:none;
            padding: 9px 0;
            background:#F7F9FC;
            font-size: 14px;
            color:#333333;
        }
    }
    &_action{
        margin-top:20px;
        text-align: center;
        /deep/ .el-button{
            padding: 11px 19px;
            font-size: 16px;
            font-weight: normal;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/orderList/components/driverModal.vue